import React, { Fragment } from 'react';
import { Intro, Video } from 'dea-core';
// import video from '../../assets/videos/DEA_OPW_M01_07_v2.mp4';
import transcript from '../../assets/videos/DEA_OPW_M01_07_v2.vtt';
// import poster from '../../assets/videos/';

const videoFiles = {
  sources: [
    {
      src:
        'https://operationprevention.com/sites/default/files/SPM_videos/module_1/DEA_OPW_M01_07_v2.mp4'
    }
  ],
  tracks: [
    {
      src: transcript,
      kind: 'captions',
      label: 'English'
    }
  ],
  poster: ''
};

export default {
  title: 'Gail on Securing Your Medication',
  path: '/elaborate/gail',
  content: (
    <Fragment>
      <Intro
        title="Gail on the importance of securing prescription medication."
        direction={'Select the play button below to begin.'}
        lead="To store your medication properly, Gail makes some recommendations…"
      />
      <Video videoFiles={videoFiles} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/Gail.js